import { graphql } from "@/gql";

export const WorkerViewQuery = graphql(/* GraphQL */ `
  query WorkerViewQuery($workerId: ID!, $companyId: ID!) {
    worker(id: $workerId) {
      ...WorkerViewFragment
    }
  }
`)

export const TrustedContactNotesView = graphql(/* GraphQL */ `
  query TrustedContactNotesView($trustedContactId: ID!) {
    trustedContact(id: $trustedContactId) {
      ...TrustedContactNotesFragment
    }
  }
`)

export const OrganisationTrustedContactNotesView = graphql(/* GraphQL */ `
  query OrganisationTrustedContactNotesView($trustedContactId: ID!) {
    trustedContact: organisationTrustedContact(id: $trustedContactId) {
      ...TrustedContactNotesFragment
    }
  }
`)

export const PartnerWorkerViewQuery = graphql(/* GraphQL */ `
  query PartnerWorkerViewQuery($workerId: ID!) {
    worker(id: $workerId) {
      ...PartnerWorkerViewFragment
    }
  }
`)
